import { useSelector } from "react-redux";
import {
  IconUserCircle,
  IconFileDescription,
  IconCalendarEvent,
  IconKey,
  IconShoppingBag,
  IconHelp,
  IconLogout,
} from "@tabler/icons-react";
import useAuth from "../../hooks/useAuth";
import { AppStore } from "../../redux/store";
import { DropdownContainer, DropdownItem, DropdownDivider } from "./components/NavDropdownUsers/DropdownItem";

const NavBarTenant = () => {
  const { country } = useSelector((store: AppStore) => store.country);
  const { handleLogout } = useAuth();

  return (
    <DropdownContainer>
      <DropdownItem icon={<IconUserCircle size={22} />} href={`/app/${country}/l/tn/mi-cuenta`}>
        Mi cuenta
      </DropdownItem>
      <DropdownItem icon={<IconFileDescription size={22} />} href={`/app/${country}/l/tn/offers`}>
        Ofertas realizadas
      </DropdownItem>
      <DropdownItem icon={<IconCalendarEvent size={22} />} href={`/app/${country}/l/tn/visits`}>
        Mis visitas
      </DropdownItem>
      <DropdownItem icon={<IconKey size={22} />} href={`/app/${country}/l/tn/payments`}>
        Mis alquileres
      </DropdownItem>
      <DropdownItem icon={<IconShoppingBag size={22} />} href={`/app/${country}/l/tn/payments-sales`}>
        Mis compras
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconHelp size={22} />} href={`/${country}/ayuda`}>
        Obtener ayuda
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconLogout size={22} />} onClick={handleLogout}>
        Cerrar sesión
      </DropdownItem>
    </DropdownContainer>
  );
};

export default NavBarTenant;
